<template>
   <p class="my-3">Copyright © BBSS Corporation. All Rights Reserved.</p>
</template>


<script>
  export default {
    name: 'quiz-footer'
  }
</script>


<style lang="scss">
  footer{
    color:#777;
    font-size:0.85rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/QuizFooter.vue